'use client'
import { getProfileDetail } from "@/apis/profile"
import { AppConfigQueryOption } from "@/apis/query/common"
import { useUserStore } from "@/store/useUserStore"
import { useDisclosure } from "@heroui/react"
import { useQuery } from "@tanstack/react-query"
import { useEffect } from "react"
import { hasMembership } from "./pendingSubscribe"
import { consumeVipExpirePrompt } from "./vipExpirePrompt"
import type { SubscribeFailCheckStatus } from "./usePendingSubscribeFail"

// Strict Mode / 同一次详情刷新只 toast 一次
let toasted = false

export const useVipExpirePrompt = (
  onShowToast: () => void,
  subscribeFailStatus: SubscribeFailCheckStatus = "idle",
) => {
  const modal = useDisclosure()
  const [isLogined, isPending] = useUserStore((state) => [state.isLogined, state.isPending])

  const detail = useQuery({
    queryKey: ["user", "detail"],
    queryFn: () => getProfileDetail(),
    enabled: isLogined && !isPending,
    retry: false,
  })
  const appConfig = useQuery(AppConfigQueryOption)

  useEffect(() => {
    if (toasted) return
    // 订阅失败优先：检查未结束先等；已弹出失败则本次不再走过期
    if (subscribeFailStatus === "checking") return
    if (subscribeFailStatus === "shown") return
    if (!isLogined || isPending || !detail.isSuccess || detail.data?.status !== 200) return

    const data = detail.data?.data
    if (!data) return
    if (hasMembership(data)) return

    const age = (data as any)?.age
    const ageGateOpen =
      (appConfig.data?.age_open_dialog ?? true) &&
      (age === null || age === undefined || Number(age) < 1)
    if (ageGateOpen) return

    const expireAt = Number(data.user_log?.vip_expire_time)
    if (!expireAt) return
    if (!consumeVipExpirePrompt(expireAt, data.user_id)) return

    toasted = true
    onShowToast()
  }, [appConfig.data?.age_open_dialog, detail.data, detail.isSuccess, isLogined, isPending, onShowToast, subscribeFailStatus])

  return modal
}
